<nav class="flex-start align-center flex-between">

        <div class="brand-pic-container">
            <a href="/">
                <picture>
                    <img src="../../assets/icons/stepup-logo02-DPP 3.svg" width="150" height="54" type="image/png">
                </picture>
            </a>
            <a mat-button href="/" routerLinkActive="selected">Home</a>
            <a mat-button href="/pricing" routerLinkActive="selected">Pricing</a>
            <a mat-button href="/meet-our-instructors" routerLinkActive="selected">Meet Our Instructors</a>
        </div>
        <button mat-raised-button (click)="pwaInstall.openPrompt()" type="button">Try Free for 30 Days!</button>
        <button mat-icon-button [matMenuTriggerFor]="navMenu">
            <mat-icon>menu</mat-icon>
        </button>


        <!--<pwa-install
        mat-button
        manifestPath="manifest.webmanifest"
        ></pwa-install>-->
</nav>
<pwa-install usecustom="true" #pwaInstall manifestPath="manifest.webmanifest"></pwa-install>

<mat-menu #navMenu="matMenu">
        <a mat-menu-item routerLink="/">Home</a>
        <a mat-menu-item routerLink="/pricing">Pricing</a>
        <a mat-menu-item routerLink="/meet-our-instructors">Meet Our Instructors</a>
        <button mat-menu-item (click)="pwaInstall.openPrompt()" type="button">Try Free for 30 days</button>
</mat-menu>